import styles from "styles/component/MapNotFound.module.scss";
import Lottie from "lottie-react";
import groovyWalkAnimation from "json/map_loader_lottie.json";
export default function MapNotFound (props) {

  return (
    //  <MapWrapper>
      <div className={styles.match_wrap_full}>
        <div className={styles.match_wrap}>
            
            {/* <Lottie animationData={groovyWalkAnimation} loop={true} /> */}
          {/* <i className={styles.srch_icon}>
            <img src={asset.nodata} alt="" />
          </i> */}
          <p className={styles.red_error_txt}>Error</p>
          <p className={styles.gray_txt}>Something went Wrong </p>
          {/* <CustomButton>Cancel</CustomButton> */}
          {/* <Link to={"#"} className={styles.blue_btn}>
            Cancel
          </Link> */}
        </div>
      </div>
    // </MapWrapper>
  );
}
